import { render, staticRenderFns } from "./processShare.vue?vue&type=template&id=47a42e57&scoped=true&"
import script from "./processShare.vue?vue&type=script&lang=js&"
export * from "./processShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a42e57",
  null
  
)

export default component.exports